import { render, staticRenderFns } from "./WorkersCompPrompt.vue?vue&type=template&id=6a72103e&scoped=true"
import script from "./WorkersCompPrompt.vue?vue&type=script&lang=js"
export * from "./WorkersCompPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72103e",
  null
  
)

export default component.exports